<div [formGroup]="parentForm">
  <div class="card-control-label">
    <mm-control-label [controlName]="cardModel.controlName" [label]="cardModel.title" [hasError]="hasError"
      [attr.data-testid]="cardModel.controlName + '-label'" >
    </mm-control-label>
  </div>
  <div id="card-control-container">
    <div *ngFor="let card of cardModel.radios" class="cards-container">
      <input type="radio" formControlName="{{cardModel.controlName}}" [value]="card.value"
      id="{{cardModel.controlName + '-' + card.value}}">
      <div class="card-content">
        <label for="{{cardModel.controlName + '-' + card.value}}">
          <div *ngFor="let line of card.label; let i = index" [ngClass]="{'firstLine': i === 0, 'gridLine': line.isNewGrid}"
            [attr.data-testid]="cardModel.controlName + '-' + card.value + '-line-' + i" 
            id="{{cardModel.controlName + '-' + card.value + '-line-' + i}}">
            {{line.label}}<span [ngClass]="{'greyLine': i !== 0}">{{line.text}}</span>
          </div>
        </label>
      </div>
    </div>
  </div>
  <span *ngIf="hasError && cardModel.radios.length > 0" class="error-text">{{errorText}}</span>
</div>
